/**
 * Email plugin action-interface declarations.
 *
 * @module
 */

import type { ActionInterfaceDef } from '../../plugin.js';

export const emailActionInterfaces: ActionInterfaceDef[] = [
  {
    slug: 'email-sent-messages',
    label: 'Read emails the app sent',
    description:
      'Return the emails the app sent via any emulated provider since boot (or the last reset), for assertions.',
    inputSchema: { type: 'object', properties: {} },
    outputSchema: {
      type: 'object',
      properties: {
        emails: {
          type: 'array',
          description: 'Captured emails: { id, provider, from, to[], subject, text, html, ... }',
        },
      },
    },
    scaffoldScript: `# Read emails the app sent to the emulated providers.
curl -sf "$EMULATION_BASE_URL/plugins/email/sent-emails" \\
  -H "Authorization: Bearer $EMULATION_CONTROL_TOKEN"`,
  },
  {
    slug: 'email-reset',
    label: 'Clear captured emails',
    description: 'Reset the email emulator, discarding all captured emails.',
    inputSchema: { type: 'object', properties: {} },
    outputSchema: { type: 'object', properties: { ok: { type: 'boolean' } } },
    scaffoldScript: `# Discard all captured emails.
curl -sf -X POST "$EMULATION_BASE_URL/plugins/email/reset" \\
  -H "Authorization: Bearer $EMULATION_CONTROL_TOKEN"`,
  },
];
